// extracted by mini-css-extract-plugin
export default {"wrapper":"TipDetail_wrapper__bhXUz","title":"TipDetail_title__3ePGJ","introduce":"TipDetail_introduce__BnrAl","meta":"TipDetail_meta__QX-uh","loading":"TipDetail_loading__1eB4A"};